/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import FormFilter from "../../shared/forms/FormFilter/FormFilter";
import useApiIncidencia from "../../api/administracion/useApiIncidencia";
import useForm from "../../shared/forms/useForm";
import Filters from "../../shared/forms/FormFilter/Filters";
import Field from "../../shared/forms/Field";
import FormTextBox from "../../shared/forms/FormFields/FormTextBox";
import Buttons from "../../shared/forms/FormFilter/Buttons";
import ButtonIcon from "../../shared/controls/ButtonIcon";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import agGridHelper from "../../shared/ag-grid-helper";
import FormMultiSelect from "../../shared/forms/FormFields/FormMultiSelect";
import FormCalendarRange from "../../shared/forms/FormFields/FormCalendarRange";
import moment from "moment";
import FormInputNumber from "../../shared/forms/FormFields/FormInputNumber";
import FormDropDown from "../../shared/forms/FormFields/FormDropDown";
import constantes from "../../catalogos/constantes";
import { FormattedDate } from "react-intl";
import IncidenciaDetalle from "./incidenciaDetalle";
import Cargo from "./Edicion/cargo";
import { getSessionState } from "../../hooks/useSessionState";
import useSessionState from "../../hooks/useSessionState";
import { useAuth } from "../../Seguridad/AuthProvider";
import FieldCheckBox from "../../shared/controls/fieldCheckBox";
import Departamentos from "./Departamentos";
import PrioridadTemplate from "./PrioridadTemplate";
import constantesAdministracion from "../../administracion/constantes";
const filtroInicial = {
  fecha: [
    moment().subtract(7, "days").startOf("day")._d,
    moment().startOf("day")._d,
  ],
  enBaja: false,
};
const Incidencia = () => {
  const api = useApiIncidencia();
  const [datos, setDatos] = useState([]);
  const [incidenciaId, setIncidenciaId] = useState(null);
  const {
    values: filter,
    onChange: onFilterChange,
    onClear,
  } = useForm(filtroInicial);
  const puedeEditar = true;
  const [agregarCargo, setAgregarCargo] = useState(false);
  const [id, setId] = useState(null);
  const filtroKey = "FiltroIncidencias";
  const [filtro, setFiltro] = useSessionState(filtroKey, {}, filtroInicial);
  const { user: usuario } = useAuth();
  const [conCosto, setConCosto] = useState(false);
  const [departamentoId, setDepartamentoId] = useState(0);
  const [enBaja, setEnBaja] = useState(false);

const handleEnBajaChange = (value) => {
  setEnBaja(value);
};
  const filtrar = async (filtro, departamentoFiltroId) => {
    const newFiltro = {
      ...filtro,
      departamentoId: departamentoFiltroId ?? departamentoId,
      conCosto: conCosto,
    };
    const datos = await api.filtrar(newFiltro);
    setDatos(datos);
    setFiltro(filtro);
  };

  const handleConCostoChange = async (e) => {
    const nuevoValor = e;
    setConCosto(nuevoValor);
    console.log(conCosto);
  };

  const solicitante = {
    id: usuario.empleadoId,
    nombre: usuario.nombre,
  };
  const nuevoCargo = (id) => {
    setId(id);
    setAgregarCargo(true);
  };

  function exportar() {
    var filtro = getSessionState(filtroKey);
    if (filtro !== null) api.excel(filtro);
  }

  const ButtonsHeader = () => (
    <div className={"ag-grid header-icons"}>
      <ButtonIcon
        title={"Descargar"}
        onClick={exportar}
        iconName={"BiDownload"}
      />

      {puedeEditar && (
        <ButtonIcon
          title="Agregar"
          className={"grid-action"}
          iconName={"MdAddBox"}
          onClick={() => setIncidenciaId(0)}
        />
      )}
    </div>
  );

  const DateCellRenderer = ({ value }) => (
    <div>
      <FormattedDate value={value} weekday="short" /> &nbsp;
      {moment(value).format("DD/MM/YYYY")}
    </div>
  );

  const ButtonsDetail = ({ data, context }) => (
    <div className={"ag-grid row-icons"}>
      {data.agregarCargo && (
        <ButtonIcon
          title={"Agregar Cargo"}
          iconName={"MdAddBox"}
          onClick={() => nuevoCargo(data.id)}
        />
      )}
      <ButtonIcon
        title={"Editar"}
        iconName={"FaRegEdit"}
        onClick={() => context.onEdit(data.id)}
      />
    </div>
  );

  const NivelCellRenderer = (value) => {
    const prioridad = value?.data?.prioridad;

    if (prioridad === constantesAdministracion.prioridadIncidencia.Nivel1) {
      return (
        <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          <img src="../../../../img/nivel1.png" alt="Nivel 1" width="15px" />
          Nivel 1
        </span>
      );
    }

    if (prioridad === constantesAdministracion.prioridadIncidencia.Nivel2) {
      return (
        <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          <img src="../../../../img/nivel2.png" alt="Nivel 2" width="15px" />
          Nivel 2
        </span>
      );
    }

    if (prioridad === constantesAdministracion.prioridadIncidencia.Nivel3) {
      return (
        <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          <img src="../../../../img/nivel3.png" alt="Nivel 3" width="15px" />
          Nivel 3
        </span>
      );
    }

    return null;
  };

  const onChangeDepartamento = async (id) => {
    setDepartamentoId(id);
    await filtrar(filtro, id);
  };

  return (
    <div className="main-screen caja">
      <Departamentos
        departamentoActivoId={departamentoId}
        onChange={onChangeDepartamento}
      />
      <div className="divider" />
      <FormFilter
        columns={8}
        filter={filter}
        onChange={onFilterChange}
        onClear={onClear}
        onFilter={filtrar}
      >
        <Filters>
          <Field
            field={"folio"}
            label={"Folio"}
            render={FormTextBox}
            cols={1}
          />
          <Field
            field={"cartaPorte"}
            label={"Carta Porte"}
            render={FormInputNumber}
            cols={1}
          />
          <Field
            field={"prioridadIds"}
            label={"Prioridad"}
            itemTemplate={PrioridadTemplate}
            render={FormMultiSelect}
            showClear={true}
            source={"general/PrioridadIncidencia"}
          />
          <Field
            field="operadorId"
            label="Operador"
            cols={2}
            render={(props) => (
              <FormDropDown
                {...props}
                key={`operador-${enBaja}`}
                source="empleados"
                params={{
                  puestoIds: [constantes.puestos.operador],
                  todasLasEmpresas: true,
                  enBaja: enBaja,
                  esquemaPago: constantes.esquemaPago.liquidacion,
                  excluirProveedorPagoId: 95,
                }}
              />
            )}
          />
          <Field
            field={"unidadId"}
            label={"Unidad"}
            source="unidades"
            render={FormDropDown}
            cols={1}
          />
          <Field
            field={"tipoId"}
            label={"Tipo de Incidencia"}
            source="tipoIncidencias"
            render={FormMultiSelect}
            params={{ departamentoId: 0 }}
            cols={1}
          />
          <Field
            field={"estatusIds"}
            label={"Estatus"}
            source="estatusIncidencias"
            render={FormMultiSelect}
            cols={1}
          />
          <Field
            field={"fecha"}
            label={"Fecha"}
            render={FormCalendarRange}
            cols={1}
          />
          <Field
            field={"solicitanteIds"}
            label={"Solicitante"}
            source="empleados"
            params={{ todasLasEmpresas: true }}
            render={FormMultiSelect}
            cols={2}
            showFilter
          />
          <Field
            field={"atendioId"}
            label={"Atendio"}
            source="empleados"
            params={{ todasLasEmpresas: true }}
            render={FormMultiSelect}
            cols={1}
            showFilter
          />
          <Field
            field={"coordinadorId"}
            label={"Coordinador"}
            source="empleados"
            params={{
              puestoIds: [
                constantes.puestos.coordinadorTrafico,
                constantes.puestos.auxiliarTrafico,
              ],
              todasLasEmpresas: true,
            }}
            render={FormMultiSelect}
            cols={2}
            showFilter
          />
          <Field
            field="enBaja"
            label="Empleado en Baja"
            render={({ field }) => (
<FieldCheckBox
  {...field}
  value={enBaja}
  onChange={handleEnBajaChange}
/>            )}
          />
          <Field
            name="conCosto"
            field={"conCosto"}
            label="Costo"
            render={({ field }) => (
              <FieldCheckBox
                {...field}
                checked={conCosto}
                onChange={handleConCostoChange}
              />
            )}
          />
        </Filters>
        <Buttons filter={true} clear={true}></Buttons>
      </FormFilter>
      <div className="ag-theme-balham grid-principal">
        <AgGridReact
          components={{
            buttonsHeader: ButtonsHeader,
            buttonsDetail: ButtonsDetail,
            dateCellRenderer: DateCellRenderer,
            nivelIncidenciaCellRenderer: NivelCellRenderer,
          }}
          onGridReady={() => filtrar(filter).then()}
          rowData={datos}
          overlayLoadingTemplate={agGridHelper.loadingOverlay}
          defaultColDef={agGridHelper.defaultColumns}
          context={{ onEdit: (id) => setIncidenciaId(id) }}
        >
          <AgGridColumn field="folio" headerName="Folio" cellClass="center" />
          <AgGridColumn
            field="cartaPorte"
            headerName="Carta Porte"
            cellClass="center"
          />
          <AgGridColumn
            maxWidth={200}
            field="prioridad"
            cellClass={"imagen"}
            cellRenderer="nivelIncidenciaCellRenderer"
          />
          <AgGridColumn
            field="operador"
            headerName="Operador"
            flex={5}
            minWidth={240}
          />
          <AgGridColumn
            field="atendio"
            headerName="Atendio"
            flex={5}
            minWidth={240}
          />
          <AgGridColumn field="unidad" headerName="Unidad" cellClass="center" />
          <AgGridColumn
            field="fechaIncidencia"
            headerName="Fecha Incidencia"
            cellClass="center"
            cellRenderer="dateCellRenderer"
            maxWidth={150}
          />
          <AgGridColumn
            field="estatusNombre"
            headerName="Estatus"
            cellClass="center"
          />
          <AgGridColumn
            field="lugarEvento"
            headerName="Lugar y Evento"
            cellClass="center"
          />
          <AgGridColumn field="tipo" headerName="Tipo" cellClass="center" />
          <AgGridColumn
            field="subTipo"
            headerName="SubTipo"
            cellClass="center"
          />
          <AgGridColumn
            field="costo"
            headerName="Costo"
            cellClass="right"
            valueFormatter={agGridHelper.currencyFormatter}
          />
          <AgGridColumn
            field="descuento"
            headerName="Descuento"
            cellClass="right"
            valueFormatter={agGridHelper.currencyFormatter}
          />
          <AgGridColumn
            field="saldo"
            headerName="Saldo"
            cellClass="right"
            valueFormatter={agGridHelper.currencyFormatter}
          />
          <AgGridColumn field="estado" headerName="Estado" cellClass="center" />
          <AgGridColumn
            maxWidth={80}
            headerName="VER"
            pinned={"right"}
            headerComponent="buttonsHeader"
            cellClass={"left"}
            cellRenderer="buttonsDetail"
          />
        </AgGridReact>
      </div>
      <IncidenciaDetalle
        incidenciaId={incidenciaId}
        puedeEditar={puedeEditar}
        onSaved={() => {
          filtrar(filter).then();
          setIncidenciaId(null);
        }}
        onCancel={() => setIncidenciaId(null)}
        onRefresh={() => filtrar(filter).then()}
        empleado={solicitante}
      />
      <Cargo
        visible={agregarCargo}
        onClose={() => setAgregarCargo(false)}
        onSaved={() => {
          filtrar(filter).then();
          setAgregarCargo(false);
        }}
        incidenciaId={id}
      />
    </div>
  );
};

export default Incidencia;
